module.exports = __webpack_public_path__ + "static/img/baseinfo-top-icon.3c1582f5.png";